// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader@7.1.2_@rspack+core@1.3.4_@swc+helpers@0.5.5__webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader@7.1.2_@rspack+core@1.3.4_@swc+helpers@0.5.5__webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cm-s-juejin.CodeMirror {
  background: #f8f9fa;
}
.cm-s-juejin .cm-header,
.cm-s-juejin .cm-def {
  color: #1ba2f0;
}
.cm-s-juejin .cm-comment {
  color: #009e9d;
}
.cm-s-juejin .cm-quote,
.cm-s-juejin .cm-link,
.cm-s-juejin .cm-strong,
.cm-s-juejin .cm-attribute {
  color: #fd7741;
}
.cm-s-juejin .cm-url,
.cm-s-juejin .cm-keyword,
.cm-s-juejin .cm-builtin {
  color: #bb51b8;
}
.cm-s-juejin .cm-hr {
  color: #909090;
}
.cm-s-juejin .cm-tag {
  color: #107000;
}
.cm-s-juejin .cm-variable-2 {
  color: #0050a0;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/.pnpm/codemirror@5.65.19/node_modules/codemirror/theme/juejin.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":[".cm-s-juejin.CodeMirror {\n  background: #f8f9fa;\n}\n.cm-s-juejin .cm-header,\n.cm-s-juejin .cm-def {\n  color: #1ba2f0;\n}\n.cm-s-juejin .cm-comment {\n  color: #009e9d;\n}\n.cm-s-juejin .cm-quote,\n.cm-s-juejin .cm-link,\n.cm-s-juejin .cm-strong,\n.cm-s-juejin .cm-attribute {\n  color: #fd7741;\n}\n.cm-s-juejin .cm-url,\n.cm-s-juejin .cm-keyword,\n.cm-s-juejin .cm-builtin {\n  color: #bb51b8;\n}\n.cm-s-juejin .cm-hr {\n  color: #909090;\n}\n.cm-s-juejin .cm-tag {\n  color: #107000;\n}\n.cm-s-juejin .cm-variable-2 {\n  color: #0050a0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
